import { format, parseISO } from "date-fns";

export const formatTime = (time: string) => {
  const now = new Date();
  const createdDate = parseISO(time);

  const secondsDiff = Math.floor(
    (now.getTime() - createdDate.getTime()) / 1000
  );
  if (secondsDiff < 60) return "1 minute ago";

  const minutesDiff = Math.floor(secondsDiff / 60);
  if (minutesDiff < 60) return `${minutesDiff} minutes ago`;

  const hoursDiff = Math.floor(minutesDiff / 60);
  if (hoursDiff < 24) return `${hoursDiff}h`;

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  if (createdDate.toDateString() === yesterday.toDateString()) {
    return `Yesterday at ${format(createdDate, "h:mm a")}`;
  }

  return format(createdDate, "MMMM do 'at' h:mm a");
};

export const highlightText = (text: string, searchText: string) => {
  if (!searchText) return text;

  const regex = new RegExp(`(${searchText})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === searchText.toLowerCase() ? (
      <mark
        key={index}
        style={{
          backgroundColor: "#d82c89",
          color: "#fff",
          padding: "0 px",
          borderRadius: "6px",
        }}
      >
        {part}
      </mark>
    ) : (
      part
    )
  );
};

export const filterPosts = (
  posts: any[],
  searchText: string,
  filter: string
) => {
  const filteredPosts = posts
    .filter((post) => {
      const matchesText =
        post.organizationName
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
        post.description.toLowerCase().includes(searchText.toLowerCase());

      const postTimeMinutesAgo = Number(post.time);
      const now = new Date();

      if (filter === "thisWeek") {
        const weekAgo = new Date();
        weekAgo.setMinutes(now.getMinutes() - 7 * 24 * 60);
        const isInThisWeek =
          now.getTime() - postTimeMinutesAgo * 60 * 1000 >= weekAgo.getTime();
        return matchesText && isInThisWeek;
      }
      if (filter === "thisMonth") {
        const monthAgo = new Date();
        monthAgo.setMinutes(now.getMinutes() - 30 * 24 * 60);
        const isInThisMonth =
          now.getTime() - postTimeMinutesAgo * 60 * 1000 >= monthAgo.getTime();
        return matchesText && isInThisMonth;
      }
      if (filter === "thisYear") {
        const yearAgo = new Date();
        yearAgo.setMinutes(now.getMinutes() - 365 * 24 * 60);
        const isInThisYear =
          now.getTime() - postTimeMinutesAgo * 60 * 1000 >= yearAgo.getTime();
        return matchesText && isInThisYear;
      }

      return matchesText;
    })
    .sort((a, b) => {
      if (filter === "Most Liked") {
        return b.likesCount - a.likesCount;
      }
      if (filter === "Most Recent") {
        return Number(a.time) - Number(b.time);
      }
      return 0;
    });

  return filteredPosts;
};
